// extracted by mini-css-extract-plugin
export default {"message":"notification__message___w8c01"};